import "./general/general";
import { Tabs } from "./blocks/spy-tabs";
import "./blocks/lectors";
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {
    if ( document.querySelector('.spy-tabs__wrapper')) {
        const tabs = new Tabs();
        tabs.init();
    }
    const lightbox = GLightbox({ selector: "._lightbox" });
    window.$("#subscribe-form").validate({
        submitHandler: function (form) {
          form.submit();
        },
        errorElement: "span",
        errorClass: "_error",

        errorPlacement: function (error, element) {
          error.appendTo(
            element.parent(".outline-field__body").siblings(".outline-field__helper")
          );
        },
        highlight: function (element, errorClass, validClass) {
          window.$(element).parent(".outline-field__body").addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
          window.$(element).parent(".outline-field__body").removeClass(errorClass);
        },
        rules: {
          name: {
            required: true,
            minlength: 2,
          },
          email: {
            required: true,
            email: true,
          },
          phone: {
            required: true,
            minlength: 11,
            regexp: true,
          },
          city: {
            required: true,
            minlength: 3,
          },
          address: {
              required: true
          },
          speciality: {
              required: true
          }
        },
        messages: {
          name: {
            required: "Поле обязательно для заполнения",
            minlength: "Введите корректное имя",
          },
          phone: {
            required: "Поле обязательно для заполнения",
            minlength: "Длина номера должна составлять не менее 11 цифр",
            number: "Номер телефона должен состоять только из цифр"
          },
          email: {
            required: "Поле обязательно для заполнения",
            email: "Введите адрес электронной почты в формате name@domain.com",
          },
          city: {
            required: "Поле обязательно для заполнения",
            minlength: "Введите корректное имя",
          },
          address: {
              required: "Поле обязательно для заполнения",
          },
          speciality: {
              required: "Поле обязательно для заполнения",
          }
        },
      });
    function promocode(button, url, course_id) {
        $.ajax({
            type: 'POST',
            url: url,
            data: {
                code: $('#subscribe-promo').val(),
                _csrf: yii.getCsrfToken(),
                course_id: course_id,
                bonus: $('#subscribe-bonus').val(),
            },
            error: () => {
                window.notify.error('Произошла ошибка');
            }
        }).done(( msg ) => {
            msg = JSON.parse(msg);
            if(msg.result == 'success') {
                renderPrice(msg.price, msg.totalPrice, msg.discount);
                button.classList.add('disabled');
                window.notify.success('Промокод принят');
            }else if(msg.result == 'error') {
                renderPrice(msg.price, msg.totalPrice, msg.discount);
                window.notify.error(msg.errors);
            }
        });
    }
    $('.js-submit-promo').on('click', function() {
        promocode(this, this.dataset.url, this.dataset.id);
    });

    function renderPrice(price, totalPrice, discount) {
        var total = document.querySelector('.js-course-price span:first-child');
        var dis  = document.querySelector('.js-course-discount span:first-child');


        total.innerHTML = totalPrice;
        if(discount == 0) {
            document.querySelector('.js-course-discount').innerHTML = '';
            document.querySelector('.js-course-price-withour-dis').innerHTML = '';
            return;
        }else{
            document.querySelector('.js-course-price-withour-dis').innerHTML = price + ' <span>₽</span>';
        }
        if (dis) {
            dis.innerHTML = discount;
        }else{
            var dis  = document.querySelector('.js-course-discount');
            dis.innerHTML = ('<span>'+discount+'</span> экономия');
        }
    }
 });

